import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, type CanActivate, type RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@infra/auth/auth.service';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthAdminGuard implements CanActivate {
  private readonly authService = inject(AuthService);

  canActivate(
    _next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    localStorage.setItem('authRedirect', state.url);

    if (this.authService.tokenValid && (this.authService.isAgentAdmin || this.authService.isGlobalAdmin)) {
      return true;
    } else {
      this.authService.clearRedirect();
      this.authService.login();
      return false;
    }
  }
}
